import { View } from 'foundations-components/components/View';
import FiltersBarLayoutManagerFilterComponent from './FiltersBarLayoutManagerFilterComponent';
import { jsx as _jsx } from "react/jsx-runtime";
const FiltersBarQuickFiltersItem = ({
  children,
  onVisibilityChange,
  isVisible = true,
  isFirst = false
}) => {
  if (!isVisible) {
    return null;
  }

  // If onVisibilityChange is provided, we need to use the FiltersBarLayoutManagerFilterComponent
  // to track the visibility of the filter component item
  if (onVisibilityChange) {
    return /*#__PURE__*/_jsx(View, {
      as: "span",
      marginInlineStart: !isFirst ? '200' : '0',
      children: /*#__PURE__*/_jsx(FiltersBarLayoutManagerFilterComponent, {
        onQuickFilterVisibilityChange: onVisibilityChange,
        children: children
      })
    });
  }
  return /*#__PURE__*/_jsx(View, {
    as: "span",
    marginInlineStart: !isFirst ? '200' : '0',
    children: children
  });
};
export default FiltersBarQuickFiltersItem;